import { request } from "@weapp/utils";
import { getTokenStorage, encryptRsa, passportHost } from "../../utils";
import { publicUrlapi } from "../../constants";

// 检测登录状态
export const checkLogin = (joinKey: any) => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/join/checkLogin?joinKey=${joinKey}`,
    method: "GET"
  });
};


// 已登录状态直接接受邀请
export const joinTenantByToken = (data: any) => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/join/joinTenantByToken?service=${encodeURIComponent(window.location.href)}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    data: formData
  });
};
// 未登录状态账号密码接受邀请
export const loginAndAcceptJoin = (params: any) => {
  // 暂时注释
  params = encryptRsa(params, 'existPassword');
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/join/loginAndAcceptJoin?service=${encodeURIComponent(window.location.href)}`,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
    method: "POST",
    data: params
  });
};
